import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Game = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M20.937 7.53C19.227 4.119 15.803 2 12 2 6.486 2 2 6.486 2 12s4.486 10 10 10c3.803 0 7.227-2.119 8.937-5.53a1 1 0 00-.397-1.316L15.017 12l5.522-3.153c.461-.264.636-.842.398-1.317zm-8.433 3.602a.999.999 0 000 1.736l6.173 3.525A7.949 7.949 0 0112 20c-4.411 0-8-3.589-8-8s3.589-8 8-8a7.95 7.95 0 016.677 3.606l-6.173 3.526z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 11.5,
    cy: 7.5,
    r: 1.5,
    key: "k1"
  }));
});
Game.displayName = 'Game';
export var GameDimensions = {
  height: 24,
  width: 24
};